import { aggregateUpdatedAction } from './store/actions'

export const createCallbacks = (dispatch, toastRef) => {

    const dispatchAggregateUpdate = (id, version) => dispatch(aggregateUpdatedAction(id, version))

    //:IReceivesNotifications
    return {
            AggregateUpdated: (id, version) => {
                dispatchAggregateUpdate(id, version)
            },
            ReapportionmentQueued: (episodeSapCode, jobCode, status, error) => {
                if (toastRef?.current) {
                    if (status === 'C') {
                        toastRef.current.show({ severity: 'info', summary: 'Reapportionment Queued',
                            detail: `Reapportionment for Episode ${episodeSapCode} has been queued (Job ${jobCode})`, life: 5000 })
                    } else {
                        toastRef.current.show({ severity: 'error', summary: 'Reapportionment Failed to Queue',
                            detail: `Reapportionment for Episode ${episodeSapCode} failed to queue: ${error}`, life: 8000 })
                    }
                }
            },
            ReapportionmentCompleted: (episodeSapCode, jobCode, status, error) => {
                if (toastRef?.current) {
                    if (status === 'C') {
                        toastRef.current.show({ severity: 'success', summary: 'Reapportionment Complete',
                            detail: `Reapportionment for Episode ${episodeSapCode} completed successfully`, life: 5000 })
                    } else if (status === 'F') {
                        toastRef.current.show({ severity: 'error', summary: 'Reapportionment Failed',
                            detail: `Reapportionment for Episode ${episodeSapCode} failed: ${error}`, life: 8000 })
                    } else {
                        toastRef.current.show({ severity: 'warn', summary: 'Reapportionment Timeout',
                            detail: `Reapportionment for Episode ${episodeSapCode} timed out`, life: 8000 })
                    }
                }
            }
        }
}
